import { PLATFORM } from '@/constants/platform'

import { LoginStrategy } from '../types'
import { DGEAuthStepStrategy } from './DGEAuthStepStrategy'
import { DGEEmailStepStrategy } from './DGEEmailStepStrategy'

const STREAMING_LOGIN_STRATEGY_STEPS = {
  EMAIL: 'email',
  AUTH: 'auth'
} as const

export const streamingLoginStrategy: LoginStrategy = {
  platform: PLATFORM.DGE,
  steps: [
    {
      id: STREAMING_LOGIN_STRATEGY_STEPS.EMAIL,
      component: DGEEmailStepStrategy
    },
    {
      id: STREAMING_LOGIN_STRATEGY_STEPS.AUTH,
      component: DGEAuthStepStrategy
    }
  ],
  getInitialStep: () => STREAMING_LOGIN_STRATEGY_STEPS.EMAIL,
  shouldUseStrategy: (platform) => platform === PLATFORM.DGE
}
